module.exports = __webpack_public_path__ + "img/jobs.9e0f672d.jpg";